import { render } from "./GoldDetailDialog.vue?vue&type=template&id=771963b1&scoped=true"
import script from "./GoldDetailDialog.vue?vue&type=script&lang=js"
export * from "./GoldDetailDialog.vue?vue&type=script&lang=js"

import "./GoldDetailDialog.vue?vue&type=style&index=0&id=771963b1&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771963b1"]])

export default __exports__